import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { SpaResourceMetricsControllerWithActions } from './main';

export const SpaTransitionResources = withAnalyticsEvents()(
	// @ts-expect-error - TS2345 - Argument of type '({ createAnalyticsEvent, }: SpaResourceMetricsControllerWithActionsProps) => JSX.Element' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & (({ createAnalyticsEvent, }: SpaResourceMetricsControllerWithActionsProps) => Element)) | ((new (props: WithAnalyticsEventsProps) => Component<...'.
	SpaResourceMetricsControllerWithActions,
);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { setPrefetchStartMark } from './utils/prefetch-timing';
